/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stock_Topical_Ocelot_HurlInputs */

const fr_stock_topical_ocelot_hurl = /** @type {(inputs: Stock_Topical_Ocelot_HurlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer photo`)
};

/**

* @param {Stock_Topical_Ocelot_HurlInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const stock_topical_ocelot_hurl = /** @type {((inputs?: Stock_Topical_Ocelot_HurlInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stock_Topical_Ocelot_HurlInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_stock_topical_ocelot_hurl(inputs)
});